import React from 'react';
import { Box } from '@mui/material';
import type { PatternVolumeKind } from '../../domain/incidents/patternReviewScopeSemantics';
import type { ReviewWindowContext } from '../../domain/incidents/reviewWindowContext';
import { GroupedUnderstandRiskScanCards } from './GroupedUnderstandRiskScanCards';

export type GroupedUnderstandRiskPanelProps = {
  riskPatternSummary?: React.ReactNode;
  recurringRiskSummary: string;
  patternVolumeCount: number;
  patternVolumeKind?: PatternVolumeKind;
  reviewWindowContext: ReviewWindowContext;
  locationLine: string;
  policyLabel: string;
  patternOwner: string;
  followUpOwner: string;
  followUpStatus: string;
  workflowStatus?: string;
  nextReviewSummary: string;
  workOrderSummary: string;
  patternDecisionCard: React.ReactNode;
  heatmapSection: React.ReactNode;
  /** @deprecated Workflow accordion already advances to Evidence review. */
  onContinueToVerifyEvidence?: () => void;
};

export const GroupedUnderstandRiskPanel: React.FC<GroupedUnderstandRiskPanelProps> = ({
  riskPatternSummary,
  patternVolumeCount,
  patternVolumeKind,
  reviewWindowContext,
  locationLine,
  policyLabel,
  patternOwner,
  followUpOwner,
  followUpStatus,
  workflowStatus,
  nextReviewSummary,
  workOrderSummary,
  patternDecisionCard,
  heatmapSection,
}) => (
  <Box data-testid="grouped-understand-risk-panel">
    {riskPatternSummary ? (
      <Box sx={{ mb: 1.5 }} data-testid="grouped-risk-pattern-summary">
        {riskPatternSummary}
      </Box>
    ) : null}

    <GroupedUnderstandRiskScanCards
      patternVolumeCount={patternVolumeCount}
      patternVolumeKind={patternVolumeKind}
      reviewWindowContext={reviewWindowContext}
      locationLine={locationLine}
      policyLabel={policyLabel}
      patternOwner={patternOwner}
      followUpOwner={followUpOwner}
      followUpStatus={followUpStatus}
      workflowStatus={workflowStatus}
      nextReviewSummary={nextReviewSummary}
      workOrderSummary={workOrderSummary}
    />

    <Box sx={{ mb: 1.5 }}>{heatmapSection}</Box>
    <Box sx={{ mb: 1.5 }}>{patternDecisionCard}</Box>
  </Box>
);

export default GroupedUnderstandRiskPanel;
